<script setup lang="ts">
import { ref, computed, onMounted } from 'vue'
import { baseUrl } from '@/core'

const props = defineProps<{
  src: string
  autoplay?: boolean
  preload?: string
}>()

const emit = defineEmits<{
  play: []
  pause: []
  ended: []
}>()

// State -----------------------------------------
const videoRef = ref<HTMLVideoElement>()
const showReplayButton = ref(true)
const showPlayButton = ref(true)
const showPauseButton = ref(false)
const videoStyle = ref()

// Getters ---------------------------------------

// Methods ---------------------------------------
onMounted(() => {
  // console.log('onMounted()')
  if (props.autoplay) play()
  if (props.preload) {
    videoStyle.value = { background: `url(${props.preload})` }
  }
})

function replay() {
  if (videoRef.value) {
    videoRef.value.pause()
    videoRef.value.currentTime = 0
    play()
  }
}

function play() {
  showReplayButton.value = true
  showPlayButton.value = false
  showPauseButton.value = true
  if (videoRef.value) {
    videoRef.value.play()
  }
}

function pause() {
  showReplayButton.value = true
  showPlayButton.value = true
  showPauseButton.value = false
  if (videoRef.value) {
    videoRef.value.pause()
  }
}

// Events ----------------------------------------
function onEnded() {
  showReplayButton.value = true
  showPlayButton.value = false
  showPauseButton.value = false
  if (videoRef.value) {
    videoRef.value.currentTime = 0
    showPlayButton.value = true
  }
  emit('ended')
}

function onPause() {
  emit('pause')
}

function onPlay() {
  emit('play')
}
// Main Setup ------------------------------------
defineExpose({
  play,
})

// -----------------------------------------------
</script>

<template>
  <div class="video-player">
    <video
      ref="videoRef"
      width="1049"
      height="590"
      :autoplay="props.autoplay"
      @ended="onEnded"
      @pause="onPause"
      @play="onPlay"
      :style="videoStyle"
    >
      <source :src="props.src" type="video/mp4" />
      Your browser does not support the video tag.
    </video>

    <img class="controls-bg" src="/images/video-controls-bg.png" />
    <img class="btn btn-play" src="/images/btn-play.png" />
    <img class="btn btn-pause" src="/images/btn-pause.png" />

    <transition name="fade">
      <img v-if="showReplayButton" class="btn btn-replay" src="/images/btn-replay-a.png" @click="replay" />
    </transition>
    <transition name="fade">
      <img v-if="showPlayButton" class="btn btn-play" src="/images/btn-play-a.png" @click="play()" />
    </transition>
    <transition name="fade">
      <img v-if="showPauseButton" class="btn btn-pause" src="/images/btn-pause-a.png" @click="pause()" />
    </transition>
  </div>
</template>

<style scoped>
/* ------------------------ */
.video-player {
  position: absolute;
  /* left: 728px;
  top: 55px; */
  width: 1115px;
  height: 656px;
  background: url('/images/video-player-bg.png');
}

.video-player video {
  position: absolute;
  left: 31px;
  top: 31px;
  background-color: #000;
}

.video-player .controls-bg {
  position: absolute;
  left: 460px;
  top: 555px;
}

.video-player .btn {
  position: absolute;
  cursor: pointer;
}

.video-player .btn-replay {
  left: 462px;
  top: 550px;
}

.video-player .btn-play {
  left: 517px;
  top: 550px;
}

.video-player .btn-pause {
  left: 595px;
  top: 550px;
}

/* ------------------------ */
</style>
